import { useQuery } from "@tanstack/react-query";
import { productsService, type ListProductsParams } from "@/services/products.service";

export const useProducts = (params: ListProductsParams = {}) =>
  useQuery({
    queryKey: ["products", params],
    queryFn: () => productsService.list(params),
  });

export const useAdminProducts = (params: ListProductsParams = {}) =>
  useQuery({
    queryKey: ["admin-products", params],
    queryFn: () => productsService.listAdmin(params),
  });

export const useProduct = (id: string | undefined) =>
  useQuery({
    queryKey: ["product", id],
    queryFn: () => (id ? productsService.getById(id) : null),
    enabled: !!id,
  });

export const useProductBySlug = (slug: string | undefined) =>
  useQuery({
    queryKey: ["product-slug", slug],
    queryFn: () => (slug ? productsService.getBySlug(slug) : null),
    enabled: !!slug,
  });